import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Calc from "./views/Calc.vue";
import calcPaperBug from "./views/CalcPaperBug.vue";
import Scenario from "./views/Scenario.vue";
import ScenarioEdit from "./views/ScenarioEdit.vue";
import Diecut from "./views/Diecut.vue";
import DiecutEdit from "./views/DiecutEdit.vue";
import Option from "./views/Option.vue";
import Other from "./views/Other.vue";
import Custom from "./views/Custom.vue";
import CustomEdit from "./views/CustomEdit.vue";
import PaperSize from "./views/PaperSize.vue";
import Glue from "./views/Glue.vue";
import GlueEdit from "./views/GlueEdit.vue";
import Printer from "./views/Printer.vue";
import PrinterEdit from "./views/PrinterEdit.vue";
import Coater from "./views/Coater.vue";
import CoaterEdit from "./views/CoaterEdit.vue";
import RouteMap from "./views/RouteMap.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/calc",
      name: "calc",
      component: Calc
    },
    {
      path: "/calc-paper-bug",
      name: "calcPaperBug",
      component: calcPaperBug
    },
    {
      path: "/scenario",
      name: "scenario",
      component: Scenario
    },
    {
      path: "/scenario/edit",
      name: "ScenarioEdit",
      component: ScenarioEdit
    },
    {
      path: "/diecut",
      name: "Diecut",
      component: Diecut
    },
    {
      path: "/diecut/edit",
      name: "DiecutEdit",
      component: DiecutEdit
    },
    {
      path: "/option",
      name: "Option",
      component: Option
    },
    {
      path: "/other",
      name: "Other",
      component: Other
    },
    {
      path: "/custom",
      name: "Custom",
      component: Custom
    },
    {
      path: "/custom/edit",
      name: "CustomEdit",
      component: CustomEdit
    },
    {
      path: "/paper_size",
      name: "PaperSize",
      component: PaperSize
    },
    {
      path: "/glue",
      name: "Glue",
      component: Glue
    },
    {
      path: "/glue/edit",
      name: "GlueEdit",
      component: GlueEdit
    },
    {
      path: "/printer",
      name: "Printer",
      component: Printer
    },
    {
      path: "/printer/edit",
      name: "PrinterEdit",
      component: PrinterEdit
    },
    {
      path: "/coater",
      name: "Coater",
      component: Coater
    },
    {
      path: "/coater/edit",
      name: "CoaterEdit",
      component: CoaterEdit
    },
    {
      path: "/route_map",
      name: "RouteMap",
      component: RouteMap
    }
  ]
});
